import { render, staticRenderFns } from "./ClientTabFiles.vue?vue&type=template&id=427de7d3&scoped=true&"
import script from "./ClientTabFiles.vue?vue&type=script&lang=js&"
export * from "./ClientTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427de7d3",
  null
  
)

export default component.exports